module.exports = __webpack_public_path__ + "static/media/join-us-banner-sm.5e977219.jpg";